import { t } from '@lingui/macro';
import { CenteredLayout, Flexbox, MaxWidthLayout, NonIdealState } from '@luminovo/design-system';
import { LinearProgress } from '@mui/material';
import { useUniversalImporter } from '../../context';
import { TablePreview } from './TablePreview';

export function StepPreview(): JSX.Element {
    const { state } = useUniversalImporter();
    const { importerTable } = state;

    if (!importerTable) {
        return (
            <CenteredLayout>
                <NonIdealState title={t`Import failed`} description={t`Go back to the previous step and try again.`} />
            </CenteredLayout>
        );
    }

    const progressPercentage =
        (importerTable.getRows().filter((row) => row.import).length /
            importerTable.getRows().filter((row) => !!row.record).length) *
        100;

    const rows = importerTable.getRows();

    return (
        <MaxWidthLayout sx={{ position: 'relative', height: '100%' }}>
            <Flexbox flexDirection={'column'} height={'100%'} sx={{ gap: 4 }}>
                {progressPercentage > 0.01 && (
                    <LinearProgress
                        sx={{ position: 'absolute', left: 0, top: 0, width: '100%' }}
                        variant="determinate"
                        value={progressPercentage}
                    />
                )}

                <Flexbox flexDirection={'column'} gap="16px" height={'100%'}>
                    {rows.length > 0 && <TablePreview rows={rows} />}
                </Flexbox>
            </Flexbox>
        </MaxWidthLayout>
    );
}
